import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flex: 1
  },

  container: {
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateColumns: 'minmax(220px, 360px) minmax(460px, 1fr)',
    width: '100%'
  }
}))

export default useStyles
